<template>
  <v-row class="pa-5" v-if="attributes">
    <v-col cols="12">
      <h2>Attributes Summary</h2>
    </v-col>
    <v-col cols="11">
      <v-row>
        <v-col cols="4" v-for="(item, index) in attributes" :key="index">
          <v-chip :class="item.color" class="mt-0 mb-4">
            {{ item.title }}
          </v-chip>
          <p class="" v-html="item.description"></p>
          <ul class="no-bullets">
            <li v-for="(sub, count) in item.items" :key="`${index}-${count}`">
              {{ sub }}
            </li>
          </ul>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";

export default {
  name: "ResultsAttrinutesSummary",
  data() {
    return {
      doc: null,
      attributes: [],
      dialog: false,
    };
  },
  props: {
    uid: String,
    id: String,
    model: String,
    lang: String,
  },
  mounted() {
    this.getAttributes();
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getAttributes() {
      console.log("get attributes");
      let ref = fb.attributesPt1ExCollection.where("pid", "==", this.id);
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((docs) => {
          let post = docs.data();
          post.doc.attributes.forEach((benefit) => {
            items.push(benefit);
          });
        });
        this.attributes = items;
      });
    },
  },
};
</script>
